import { z } from "zod";

const NAME_REGEX = /^[A-Za-z]+(?:[ .'-][A-Za-z]+)*$/;

export const userFormSchema = z.object({
    name: z
        .string()
        .trim()
        .min(1, "Name is required")
        .max(150, "Name must not exceed 150 characters")
        .regex(
            NAME_REGEX,
            "Name can only contain letters, spaces, apostrophes ('), hyphens (-), and periods (.)"
        ),
    username: z
        .string()
        .trim()
        .min(1, "Username is required")
        .min(3, "Username must be at least 3 characters")
        .max(50, "Username must not exceed 50 characters"),
    email: z.string().trim().email("Invalid email address").max(150, "Email must not exceed 150 characters"),

    // role is API-driven string
    roleId: z.string().trim().min(1, "Role is required"),

    // manager depends on role
    managerId: z
        .string()
        .trim()
        .nullable()
        .transform((v) => (v ? v : "")),

    // end date (optional)
    endDate: z
        .string()
        .trim()
        .optional()
        .nullable()
        .refine((v) => !v || !Number.isNaN(Date.parse(v)), {
            message: "Invalid end date",
        }),

});

export const userFormDefaultValues = {
    name: "",
    username: "",
    email: "",
    roleId: "",
    managerId: "",
    endDate: null
};

export const deleteUserReasonSchema = z.object({
    reason: z.string().trim().min(10, "Reason must be at least 10 characters"),
});

export const deleteUserReasonDefaultValues = {
    reason: "",
};

